/* eslint-disable */
import React, { useState } from "react";
import CrossIcon from "./CrossIcon/CrossIcon";
import ExclamationMarkIcon from "./ExclamationMarkIcon";

interface IGenericConfirmationPopUpProps {
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  confirmButtonText: string;
  cancelButtonText: string;
}

const GenericConfirmationPopUp: React.FC<IGenericConfirmationPopUpProps> = ({
  onCancel,
  onConfirm,
  title,
  confirmButtonText,
  cancelButtonText,
}: IGenericConfirmationPopUpProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCancelButtonDisabled, setIsCancelButtonDisabled] = useState(false);
  const onConfirmHandler = async () => {
    setIsCancelButtonDisabled(true);
    try {
      setIsLoading(true);

      await onConfirm();
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
    setIsCancelButtonDisabled(false);
  };

  return (
    <div className="fixed top-0 right-0 left-0 z-50 p-4 md:inset-0 h-full bg-gray-100 bg-opacity-80  ">
      <div className="flex justify-center items-center align-middle h-full ">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <button
            type="button"
            className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
            disabled={isCancelButtonDisabled}
            onClick={onCancel}
          >
            <CrossIcon />
            <span className="sr-only">Close modal</span>
          </button>
          <div className="p-6 text-center">
            <ExclamationMarkIcon />
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              {title}
            </h3>
            <button
              type="button"
              className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
              onClick={onConfirmHandler}
            >
              {isLoading ? (
                <img src="/loading.gif" width="20" alt="loading" />
              ) : (
                confirmButtonText
              )}
            </button>
            <button
              type="button"
              className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              disabled={isCancelButtonDisabled}
              onClick={onCancel}
            >
              {cancelButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

GenericConfirmationPopUp.defaultProps = {
  title: "Are you sure you want to delete",
  confirmButtonText: "Yes, I'm sure",
  cancelButtonText: "No, cancel",
};

export default GenericConfirmationPopUp;
